import * as React from 'react';
import { noop } from '@deltasierra/utilities-object';
import { PuppetCheckedInputProps, PuppetCheckedInput } from './CheckedInput';
import { SelectOption, isSelectOption } from './common';

export type CheckboxesInputProps = Omit<PuppetCheckboxesInputProps, 'onChange' | 'value'> & {
    initialValue?: string[];
    onChange?: (value: string[]) => void;
};

export const CheckboxesInput: React.FC<CheckboxesInputProps> = ({ initialValue = [], onChange = noop, ...props }) => {
    const [value, setValue] = React.useState(initialValue);
    const handleChange = React.useCallback(
        ({ target: { checked, value: eventValue } }: React.ChangeEvent<HTMLInputElement>) => {
            setValue(prev => {
                if (checked && !prev.includes(eventValue)) {
                    return [...prev, eventValue];
                } else if (!checked && prev.includes(eventValue)) {
                    return prev.filter(val => val !== eventValue);
                }
                return prev;
            });
        },
        [],
    );
    return <PuppetCheckboxesInput {...props} value={value} onChange={handleChange} />;
};

export type PuppetCheckboxesInputProps = Pick<PuppetCheckedInputProps, 'name' | 'onChange'> & {
    options: Array<SelectOption | string>;
    value: string[];
};

export const PuppetCheckboxesInput: React.FC<PuppetCheckboxesInputProps> = props => {
    const cleanedOptions = props.options.map(option =>
        isSelectOption(option) ? option : { label: option, value: option },
    );
    return (
        <>
            {cleanedOptions.map((option, index) => (
                <PuppetCheckedInput
                    {...option}
                    checked={props.value.includes(option.value)}
                    key={index}
                    name={props.name}
                    type="checkbox"
                    onChange={props.onChange}
                />
            ))}
        </>
    );
};
